export const consolidatedRenewalEndpoints = (builder) => ({
  /**
   * GET /api/general-insurance/consolidated-renewal
   * Params: fromDate, toDate, product
   */
  getConsolidatedRenewalList: builder.query({
    query: ({ renewalFrom, renewalTo, product, policyStatus }) => ({
      url: '/GeneralInsurance/consolidated-renewal',
      method: 'GET',
      params: { renewalFrom, renewalTo, product, policyStatus },
    }),
    providesTags: ['ConsolidatedRenewal'],
  }),
});
